import React from "react";
import { useTranslation } from "react-i18next";
import { getLocalizedTitle } from "../../../../utils/localizedText";
import "./QuotationDetails.css";

const QuotationTable = ({ items, onUnitFeeChange, onTransportationFeeChange, onAdjustmentChange }) => {
  const { t, i18n } = useTranslation();

  const parseMoney = (value) => {
    const amount = parseFloat(value);
    return Number.isFinite(amount) ? amount : 0;
  };

  const normalizeTransportationFee = (value) => {
    if (value === "") return "";
    if (/^0+\d/.test(value)) return value.replace(/^0+/, "");
    return value;
  };

  const calculateTotal = () => {
    return items.reduce((sum, item) => {
      const unitFee = parseMoney(item.unitFee);
      const transportationFee = parseMoney(item.transportationFee);
      const adjustment = parseMoney(item.adjustment);
      return sum + unitFee + transportationFee + adjustment;
    }, 0);
  };

  const formatCurrency = (amount) => `Vnd ${parseMoney(amount).toFixed(2)}`;

  return (
    <div className="quotation-table-container">
      <table className="quotation-table">
        <thead className="quotation-thead">
          <tr>
            <th>{t("serialNo")}</th>
            <th>{t("serviceName")}</th>
            <th>{t("distanceKm") || "Distance(KM)"}</th>
            <th>{t("unitFee")}</th>
            <th>{t("transportationFee")}</th>
            <th>{t("adjustment")}</th>
            <th>{t("subtotal")}</th>
          </tr>
        </thead>
        <tbody className="quotation-tbody">
          {items.map((item, index) => {
            const unitFee = parseMoney(item.unitFee);
            const transportationFee = parseMoney(item.transportationFee);
            const adjustment = parseMoney(item.adjustment);
            const subtotal = unitFee + transportationFee + adjustment;

            return (
              <tr key={index} className="quotation-row">
                <td>{index + 1}</td>
                <td>{getLocalizedTitle(item.serviceItemData || item.serviceItemTitle, i18n.language) || item.serviceName}</td>
                <td>{item.distanceInKm !== "" && item.distanceInKm !== null && item.distanceInKm !== undefined ? item.distanceInKm : "-"}</td>
                <td>
                  <input type="number" value={item.unitFee ?? ""} onChange={(e) => onUnitFeeChange(index, e.target.value)} placeholder="Vnd 0" className="adjustment-input" />
                </td>
                <td>
                  <input
                    type="number"
                    value={item.transportationFee ?? ""}
                    onFocus={(e) => e.target.select()}
                    onChange={(e) => onTransportationFeeChange(index, normalizeTransportationFee(e.target.value))}
                    placeholder="Vnd 0"
                    className="adjustment-input"
                  />
                </td>
                <td>
                  <input type="number" value={item.adjustment ?? ""} onChange={(e) => onAdjustmentChange(index, e.target.value)} placeholder="Vnd 0" className="adjustment-input" />
                </td>
                <td className="subtotal-cell">{formatCurrency(subtotal)}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot className="quotation-tfoot">
          <tr className="total-row">
            <td colSpan={6} className="total-label">
              <strong>{t("total")}</strong>
            </td>
            <td className="total-value">
              <strong>{formatCurrency(calculateTotal())}</strong>
            </td>
          </tr>
        </tfoot>
      </table>
      <p className="quotation-disclaimer">{t("quotationDisclaimer") || "Please note that actual prices may vary after the service is provided. The figures mentioned are just estimations."}</p>
    </div>
  );
};

export default QuotationTable;
